import { hexToRgba, makeSx } from '@saas/lib/shared-utils'
import { palette } from '../../../utilities'

export const sxs = makeSx({
    cardsContainer: {
        width: '100%',
        display: 'flex',
        flexDirection: { md: 'column', lg: 'row' },
        flexWrap: 'wrap',
        justifyContent: 'center',
        gap: '1rem',
        paddingTop: '1rem',
        paddingBottom: '1rem',
    },
    card: {
        width: 'auto',
        flex: 1,
        minWidth: {
            xs: '100%',
            md: 'calc(23rem - 3rem)',
            lg: 0,
        },
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '1.25rem',
        borderRadius: '1rem',
        boxShadow: `0px 5px 15px 0px ${palette.lightGrey[550]}, 0px 2px 4px 0px rgba(221, 225, 236, 0.25)`,
        border: `1px solid ${hexToRgba(palette.transmission[700], 0.06)}`,
        '& .MuiCardContent-root:last-child': {
            paddingBottom: '0',
        },
    },
    cardContent: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '1rem',
    },
    cardTitle: {
        textAlign: 'center',
        fontWeight: 'bold',
        fontSize: '1.25rem',
        color: palette.typography[900],
        '& .MuiCardHeader-title': {
            marginBottom: 0,
        },
    },
    cardDescription: {
        fontSize: '1rem',
        textAlign: 'center',
        lineHeight: '1.25rem',
        color: palette.neutral[700],
    },
    cardHoverable: {
        transition: 'boxShadow .08s ease-in',
        '&:hover': {
            boxShadow: 'none',
        },
    },
    cardActionArea: {
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '1.25rem',
        borderRadius: '1rem',
        padding: '1rem',
        backgroundColor: 'transparent',
        transition: 'background .08s ease-in',
        '&:hover': {
            background: hexToRgba(palette.transmission[700], 0.02),
        },
    },
    cardActionAreaDisabledHover: {
        cursor: 'default',
        '& .MuiCardActionArea-focusHighlight': {
            backgroundColor: 'transparent',
        },
        '&:hover': {
            background: 'transparent',
        },
    },
    cardAction: {
        width: '100%',
    },
    cardNoAction: {
        width: '100%',
        minWidth: 0,
        boxSizing: 'border-box',
        overflowWrap: 'anywhere',
        padding: '1rem',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: palette.lightGrey[520],
        borderRadius: '1rem',
        color: palette.transmission[700],
        '& .MuiTypography-root': {
            fontSize: '0.875rem',
            lineHeight: '1.375rem',
            letterSpacing: '0.17px',
            color: palette.transmission[700],
        },
    },
    cardNoActionWithEmail: {
        gap: '0.5rem',
    },
    cardIconBase: {
        width: '2.875rem',
        height: '2.875rem',
    },
    cardFilledIcon: {
        fill: palette.transmission[700],
    },
    cardWhiteOnBlueIcon: {
        color: palette.surface[100],
        backgroundColor: palette.transmission[700],
        borderRadius: '50%',
        padding: '0.5rem',
        '& path': {
            fill: palette.surface[100],
        },
    },
    buttonIcon: {
        width: '1.375rem',
        height: '1.375rem',
        fill: palette.surface[100],
    },
    buttonIconSecondary: {
        width: '1.375rem',
        height: '1.375rem',
    },
    cardActionInnerContainer: {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        justifyContent: 'center',
        maxWidth: '100%',
        gap: '7px',
        '& .MuiTypography-root, & .MuiButton-root': {
            fontSize: '1rem',
        },
    },
    button: {
        width: '100%',
        padding: '1rem',
        backgroundColor: palette.transmission[700],
        color: palette.surface[100],
        '&:hover': {
            backgroundColor: palette.transmission[700],
            opacity: 0.9,
        },
    },
    buttonSecondary: {
        backgroundColor: palette.blue[500],
        color: palette.surface[100],
        '&:hover': {
            backgroundColor: palette.blue[500],
            opacity: 0.9,
        },
    },
    buttonInnerLink: {
        color: 'inherit',
        textDecoration: 'none',
        fontWeight: 600,
    },
})
